export default __webpack_public_path__ + "static/Montserrat-Bold-fdec1a8704afeefc65270e9718295f0f.woff";